import { Box, Flex, List, ListIcon, ListItem, Stack, Text } from '@chakra-ui/react';
import { MdCheckCircle } from 'react-icons/md';
import React from 'react';

const CurrentSub = ({ planName, priceAmount, features, subLoading }) => {
    if (subLoading) {
        return (
            <Stack spacing='0' alignItems='center' w='100%' borderRadius='8px' border='1px solid #E2E8F0' bg='#fff' p='24px' boxShadow='sm'>
                <Text
                    mt='6px'
                    mb='16px'
                    fontSize='20px'
                    lineHeight='24px'
                    fontWeight='700'
                    textAlign='center'
                >
                    Current Plan:
                </Text>
                <Text fontSize='20px' lineHeight='24px' minH='24px' fontWeight='700' textAlign='center' color='#bdbdbd'>
                    Loading Plan...
                </Text>
                <Text textAlign='center' mt='38px' fontSize='30px' minH='36px' lineHeight='36px' fontWeight='700' color='#bdbdbd'>
                    $--
                </Text>
                <Text fontSize='12px' lineHeight='18px' fontWeight='400' color='#bdbdbd'>
                    /mo
                </Text>
                <Box mt='20px' textAlign='left' w='100%' pl='15px'>
                    <Text fontSize='12px' lineHeight='18px' fontWeight='400' color='#bdbdbd'>
                        Includes:
                    </Text>
                    <List mb='20px' minH='72px'>
                        {[...Array(5)].map((_, i) => (
                            <ListItem key={i}>
                                <Flex alignItems='center'>
                                    <ListIcon color='#bdbdbd' w='20px' h='20px' as={MdCheckCircle} />
                                    <Box w='120px' h='16px' bg='#e0e0e0' borderRadius='4px' ml='8px' />
                                </Flex>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Stack>
        );
    }
    return (
        <Stack spacing='0' alignItems='center' w='100%' borderRadius='8px' border='1px solid #E2E8F0'>
            <Text
                mt='30px'
                p='0px 70px'
                mb={{ base: '24px', sm: '10px', md: '12px', lg: '14px', xl: '16px' }}
                fontSize='20px'
                lineHeight='24px'
                minH='24px'
                fontWeight='700'
            >
                Current Plan:
            </Text>
            <Text fontSize='20px' lineHeight='24px' minH='24px' fontWeight='700'>
                {planName}
            </Text>
            <Text textAlign='center' mt='38px' fontSize='30px' minH='36px' lineHeight='36px' fontWeight='700'>
                ${priceAmount}
            </Text>
            <Text fontSize='12px' lineHeight='18px' fontWeight='400'>
                /mo
            </Text>
            <Box mt='20px' textAlign='left' w='100%' pl='15px'>
                <Text fontSize='12px' lineHeight='18px' fontWeight='400'>
                    Includes:
                </Text>
                <List mb='20px' minH='72px'>
                    {features?.map((feature) => (
                        <ListItem key={feature}>
                            <Flex alignItems='center'>
                                <ListIcon color='#0000007A' w='20px' h='20px' as={MdCheckCircle} />
                                <Text color='#000000A3' fontSize='12px' lineHeight='24px' fontWeight='400'>
                                    {feature}
                                </Text>
                            </Flex>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Stack>
    );
};

export default CurrentSub;
